import _defineProperty from '../../../node_modules/@babel/runtime/helpers/defineProperty.js';
import NumericField, { getNumericFieldRegisterProps } from './NumericField.js';
import jsxRuntime from '../../../node_modules/react/jsx-runtime.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var registerProps = getNumericFieldRegisterProps('Invalid down payment value');
var DownPaymentField = function DownPaymentField(props) {
  return /*#__PURE__*/jsxRuntime.jsx(NumericField, _objectSpread({
    leftAdornment: "$",
    labelText: "Down payment",
    helpText: "Most home loans require at least 3% down.",
    registerProps: registerProps
  }, props));
};
var DownPaymentField$1 = DownPaymentField;

export { DownPaymentField$1 as default };
//# sourceMappingURL=DownPaymentField.js.map
